import { defineMessage } from 'react-intl';

export const message = defineMessage({
  description: 'Error message saying the selected provider service is not available',
  defaultMessage: 'This order does not have a shipping service selected.',
  id: 'gk07/z',
});

export default () => {
  return message;
};
